import SharedStructure from "../../Constants/SharedStructure"; // Import shared structure

export const fetchSharedData = async () => {
  try {
    const response = await fetch("/api/mock/AccountPage/UserAccountSharedContentMockapi.json"); // Fetch from public folder
    const data = await response.json();

    // Format data according to SharedStructure
    const formattedData = data.map((user) => ({
      rootuser: user.rootuser || "",
      posts: (user.posts || []).map((post) => ({
        postId: post.postId || "",
        descriptions: post.descriptions || "",
        userId: post.userId || "",
        useruuid: post.useruuid || "",
        userName: post.userName || "",
        userimage: post.userimage || "",
        timestamp: post.timestamp || "",
        sharedOn: post.sharedOn || "",
        location: post.location || "",
        nlikes: post.nlikes || 0,
        medias: (post.medias || []).map((media) => ({
          mediatype: media.mediatype || "",
          mediaurl: media.mediaurl || "",
        })),
      })),
    }));

    return formattedData;
  } catch (error) {
    console.error("Error fetching shared data:", error);
    return [];
  }
};